import React from 'react';

function Skeleton({
  className = '',
  count = 1,
  rounded = false,
  size = 'medium',
}) {
  const items = Array.from({ length: Math.max(1, count) });

  return (
    <>
      {items.map((_, index) => (
        <span
          aria-hidden="true"
          className={[
            'custom-skeleton',
            `custom-skeleton--${size}`,
            rounded ? 'custom-skeleton--rounded' : '',
            className,
          ].filter(Boolean).join(' ')}
          key={index}
        />
      ))}
    </>
  );
}

export default Skeleton;
